import { render } from "./DashboardBrandManagementMain.vue?vue&type=template&id=56ed4286&ts=true"
import script from "./DashboardBrandManagementMain.vue?vue&type=script&lang=ts"
export * from "./DashboardBrandManagementMain.vue?vue&type=script&lang=ts"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__